module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (210).ff36a8d5.jpg";